"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colony = exports.ShouldIncreaseTrack = void 0;
const AddResourcesToCard_1 = require("../deferredActions/AddResourcesToCard");
const CardName_1 = require("../CardName");
const ColonyBenefit_1 = require("./ColonyBenefit");
const DeferredAction_1 = require("../deferredActions/DeferredAction");
const DiscardCards_1 = require("../deferredActions/DiscardCards");
const DrawCards_1 = require("../deferredActions/DrawCards");
const GiveColonyBonus_1 = require("../deferredActions/GiveColonyBonus");
const IncreaseColonyTrack_1 = require("../deferredActions/IncreaseColonyTrack");
const LogHelper_1 = require("../LogHelper");
const constants_1 = require("../constants");
const PlaceOceanTile_1 = require("../deferredActions/PlaceOceanTile");
const Resources_1 = require("../Resources");
const ScienceTagCard_1 = require("../cards/community/ScienceTagCard");
const SelectColony_1 = require("../inputs/SelectColony");
const SelectPlayer_1 = require("../inputs/SelectPlayer");
const StealResources_1 = require("../deferredActions/StealResources");
const Tags_1 = require("../cards/Tags");
const SendDelegateToArea_1 = require("../deferredActions/SendDelegateToArea");
const PlaceHazardTile_1 = require("../deferredActions/PlaceHazardTile");
const AresHazards_1 = require("../ares/AresHazards");
const SelectSpace_1 = require("../inputs/SelectSpace");
const SpaceBonus_1 = require("../SpaceBonus");
const Phase_1 = require("../Phase");
const Turmoil_1 = require("../turmoil/Turmoil");
const AutomaHandler_1 = require("../automa/AutomaHandler");
const VastitasBorealisBoard_1 = require("../boards/VastitasBorealisBoard");
const HellasBoard_1 = require("../boards/HellasBoard");
const TileType_1 = require("../TileType");
var ShouldIncreaseTrack;
(function (ShouldIncreaseTrack) {
    ShouldIncreaseTrack[ShouldIncreaseTrack["YES"] = 0] = "YES";
    ShouldIncreaseTrack[ShouldIncreaseTrack["NO"] = 1] = "NO";
    ShouldIncreaseTrack[ShouldIncreaseTrack["ASK"] = 2] = "ASK";
})(ShouldIncreaseTrack = exports.ShouldIncreaseTrack || (exports.ShouldIncreaseTrack = {}));
class Colony {
    constructor() {
        this.details = [];
        this.isActive = true;
        this.visitor = undefined;
        this.colonies = [];
        this.trackPosition = 1;
        this.buildQuantity = [1, 1, 1];
        this.tradeQuantity = [1, 1, 1, 1, 1, 1, 1];
        this.colonyBonusQuantity = 1;
        this.shouldIncreaseTrack = ShouldIncreaseTrack.YES;
        this.priority = 1;
    }
    endGeneration(game) {
        if (this.isActive) {
            this.increaseTrack();
        }
        if (game.syndicatePirateRaider) {
            if (game.syndicatePirateRaider === this.visitor) {
                this.visitor = undefined;
            }
            else {
                const raider = game.getPlayerById(game.syndicatePirateRaider);
                if (raider.cardIsInEffect(CardName_1.CardName.HUAN))
                    this.visitor = undefined;
            }
        }
        else {
            this.visitor = undefined;
        }
    }
    increaseTrack(value = 1) {
        this.trackPosition = Math.min(this.trackPosition + value, constants_1.MAX_COLONY_TRACK_POSITION);
    }
    decreaseTrack(value = 1) {
        this.trackPosition = Math.max(this.trackPosition - value, this.colonies.length);
    }
    isColonyFull(player, game) {
        if (game.gameOptions.equalOpportunityVariant === false) {
            return this.colonies.length >= 3;
        }
        return this.colonies.includes(player.id);
    }
    addColony(player) {
        player.game.log('${0} built a colony on ${1}', (b) => b.player(player).colony(this));
        let colonyBonusRewardPosition = this.colonies.length;
        if (player.game.gameOptions.equalOpportunityVariant === true) {
            colonyBonusRewardPosition = Math.min(colonyBonusRewardPosition, 2);
        }
        this.giveBonus(player, this.buildType, this.buildQuantity[colonyBonusRewardPosition], this.buildResource);
        this.colonies.push(player.id);
        if (this.trackPosition < this.colonies.length) {
            this.trackPosition = this.colonies.length;
        }
        const poseidon = player.game.getPlayers().find((player) => player.isCorporation(CardName_1.CardName.POSEIDON));
        if (poseidon !== undefined) {
            poseidon.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        }
        const colonyTradeHubOwner = player.game.getPlayers().find((player) => player.cardIsInEffect(CardName_1.CardName.COLONY_TRADE_HUB));
        if (colonyTradeHubOwner !== undefined) {
            colonyTradeHubOwner.addResource(Resources_1.Resources.MEGACREDITS, 2);
            if (colonyTradeHubOwner.cardIsInEffect(CardName_1.CardName.DOUBLE_DOWN)) {
                const doubleDown = colonyTradeHubOwner.playedCards.find((c) => c.name === CardName_1.CardName.DOUBLE_DOWN);
                if (doubleDown.target === CardName_1.CardName.COLONY_TRADE_HUB) {
                    colonyTradeHubOwner.addResource(Resources_1.Resources.MEGACREDITS, 2);
                }
            }
        }
        if (player.cardIsInEffect(CardName_1.CardName.NAOMI)) {
            player.addResource(Resources_1.Resources.ENERGY, 2, { log: true });
            player.addResource(Resources_1.Resources.MEGACREDITS, 3, { log: true });
        }
    }
    trade(player, tradeOptions = {}, bonusTradeOffset = 0) {
        let tradeOffset = player.colonyTradeOffset + bonusTradeOffset;
        if (player.hasTranshumansColonyTradeOffset)
            tradeOffset += 1;
        const maxTrackPosition = Math.min(this.trackPosition + tradeOffset, constants_1.MAX_COLONY_TRACK_POSITION);
        const steps = maxTrackPosition - this.trackPosition;
        if (steps === 0 || this.shouldIncreaseTrack === ShouldIncreaseTrack.NO) {
            this.handleTrade(player, tradeOptions);
            return;
        }
        if (this.shouldIncreaseTrack === ShouldIncreaseTrack.YES || (this.tradeResource !== undefined && this.tradeResource[this.trackPosition] === this.tradeResource[maxTrackPosition])) {
            this.increaseTrack(steps);
            LogHelper_1.LogHelper.logColonyTrackIncrease(player, this, steps);
            this.handleTrade(player, tradeOptions);
            return;
        }
        player.game.defer(new IncreaseColonyTrack_1.IncreaseColonyTrack(player, this, steps, () => this.handleTrade(player, tradeOptions)));
    }
    handleTrade(player, options) {
        if (player.cardIsInEffect(CardName_1.CardName.VENUS_TRADE_HUB)) {
            player.addResource(Resources_1.Resources.MEGACREDITS, 3, { log: true });
        }
        const resource = Array.isArray(this.tradeResource) ? this.tradeResource[this.trackPosition] : this.tradeResource;
        this.giveBonus(player, this.tradeType, this.tradeQuantity[this.trackPosition], resource);
        if (options.giveColonyBonuses !== false) {
            player.game.defer(new GiveColonyBonus_1.GiveColonyBonus(player, this));
        }
        if (options.usesTradeFleet !== false) {
            this.visitor = player.id;
            player.tradesThisGeneration++;
        }
        if (options.decreaseTrackAfterTrade !== false) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                this.trackPosition = this.colonies.length;
                return undefined;
            }), DeferredAction_1.Priority.DECREASE_COLONY_TRACK_AFTER_TRADE);
        }
        player.hasTradedThisTurn = true;
    }
    giveColonyBonus(player, isGiveColonyBonus = false) {
        return this.giveBonus(player, this.colonyBonusType, this.colonyBonusQuantity, this.colonyBonusResource, isGiveColonyBonus);
    }
    giveBonus(player, bonusType, quantity, resource, isGiveColonyBonus = false) {
        const game = player.game;
        let action = undefined;
        switch (bonusType) {
            case ColonyBenefit_1.ColonyBenefit.ADD_RESOURCES_TO_CARD:
                const resourceType = this.resourceType;
                action = new AddResourcesToCard_1.AddResourcesToCard(player, resourceType, { count: quantity });
                break;
            case ColonyBenefit_1.ColonyBenefit.ADD_RESOURCES_TO_VENUS_CARD:
                action = new AddResourcesToCard_1.AddResourcesToCard(player, undefined, { count: quantity, restrictedTag: Tags_1.Tags.VENUS, title: 'Select Venus card to add ' + quantity + ' resource(s)' });
                break;
            case ColonyBenefit_1.ColonyBenefit.COPY_TRADE:
                const openColonies = game.colonies.filter((colony) => colony.isActive);
                const coloniesModel = game.getColoniesModel(openColonies);
                action = new DeferredAction_1.DeferredAction(player, () => new SelectColony_1.SelectColony('Select colony to gain trade income from', 'Select', coloniesModel, (colonyName) => {
                    openColonies.forEach((colony) => {
                        if (colony.name === colonyName) {
                            game.log('${0} gained ${1} trade bonus', (b) => b.player(player).colony(colony));
                            colony.handleTrade(player, { usesTradeFleet: false, decreaseTrackAfterTrade: false, giveColonyBonuses: false });
                        }
                        return undefined;
                    });
                    return undefined;
                }));
                break;
            case ColonyBenefit_1.ColonyBenefit.DRAW_CARDS:
                action = DrawCards_1.DrawCards.keepAll(player, quantity);
                break;
            case ColonyBenefit_1.ColonyBenefit.DRAW_CARDS_AND_BUY_ONE:
                if (player.hasConceded)
                    return;
                if (player.canAfford(player.cardCost)) {
                    action = DrawCards_1.DrawCards.keepSome(player, 1, { paying: true, logDrawnCard: true });
                }
                else {
                    action = DrawCards_1.DrawCards.keepSome(player, 1, { paying: true, logDrawnCard: true, keepMax: 0 });
                }
                break;
            case ColonyBenefit_1.ColonyBenefit.DRAW_CARDS_AND_DISCARD_ONE:
                player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                    player.drawCard();
                    player.game.defer(new DiscardCards_1.DiscardCards(player, 1, this.name + ' colony bonus. Select a card to discard'), DeferredAction_1.Priority.SUPERPOWER);
                    return undefined;
                }));
                break;
            case ColonyBenefit_1.ColonyBenefit.DRAW_CARDS_AND_KEEP_ONE:
                action = DrawCards_1.DrawCards.keepSome(player, quantity, { keepMax: 1 });
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_CARD_DISCOUNT:
                player.cardDiscount += 1;
                game.log('Cards played by ${0} cost 1 M€ less this generation', (b) => b.player(player));
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_PRODUCTION:
                if (resource === undefined)
                    throw new Error('Resource cannot be undefined');
                player.addProduction(resource, quantity, { log: true });
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES:
                if (resource === undefined)
                    throw new Error('Resource cannot be undefined');
                player.addResource(resource, quantity, { log: true });
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_SCIENCE_TAG:
                player.scienceTagCount += 1;
                player.playCard(new ScienceTagCard_1.ScienceTagCard(), undefined, false);
                game.log('${0} gained 1 Science tag', (b) => b.player(player));
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_INFLUENCE:
                Turmoil_1.Turmoil.ifTurmoil(game, (turmoil) => {
                    turmoil.addInfluenceBonus(player);
                    game.log('${0} gained 1 influence', (b) => b.player(player));
                });
                break;
            case ColonyBenefit_1.ColonyBenefit.PLACE_DELEGATES:
                Turmoil_1.Turmoil.ifTurmoil(game, (turmoil) => {
                    const playerHasLobbyDelegate = turmoil.lobby.has(player.id);
                    let availablePlayerDelegates = turmoil.getDelegatesInReserve(player.id);
                    if (playerHasLobbyDelegate)
                        availablePlayerDelegates += 1;
                    const qty = Math.min(quantity, availablePlayerDelegates);
                    for (let i = 0; i < qty; i++) {
                        const fromLobby = (i === qty - 1 && qty === availablePlayerDelegates && playerHasLobbyDelegate);
                        game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send delegate', { source: fromLobby ? 'lobby' : 'reserve' }));
                    }
                });
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_MC_PER_DELEGATE:
                Turmoil_1.Turmoil.ifTurmoil(game, (turmoil) => {
                    let partyDelegateCount = constants_1.PLAYER_DELEGATES_COUNT - turmoil.getDelegatesInReserve(player.id);
                    if (turmoil.lobby.has(player.id))
                        partyDelegateCount--;
                    if (turmoil.chairman === player.id)
                        partyDelegateCount--;
                    player.addResource(Resources_1.Resources.MEGACREDITS, partyDelegateCount, { log: true });
                });
                break;
            case ColonyBenefit_1.ColonyBenefit.PLACE_HAZARD_TILE:
                const availableSpaces = game.board.getAvailableSpacesOnLand(player)
                    .filter((space => space.tile === undefined))
                    .filter((space) => {
                    const adjacentSpaces = game.board.getAdjacentSpaces(space);
                    return adjacentSpaces.filter((space) => space.tile !== undefined).length === 0;
                });
                game.defer(new PlaceHazardTile_1.PlaceHazardTile(player, game, 'Select space next to no other tile for hazard', availableSpaces));
                break;
            case ColonyBenefit_1.ColonyBenefit.ERODE_SPACES_ADJACENT_TO_HAZARDS:
                for (let i = 0; i < quantity; i++) {
                    const availableSpaces = AresHazards_1._AresHazardPlacement.getAllLandSpacesAdjacentToHazards(game);
                    if (availableSpaces.length > 0) {
                        game.defer(new DeferredAction_1.DeferredAction(player, () => new SelectSpace_1.SelectSpace("Select space adjacent to hazard tile to erode", availableSpaces, TileType_1.TileType.DUST_STORM_MILD, (foundSpace) => {
                            foundSpace.bonus.forEach((spaceBonus) => game.grantSpaceBonus(player, spaceBonus));
                            HellasBoard_1.HellasBoard.handleBonusOceanFromTilePlacement(game, player, foundSpace);
                            VastitasBorealisBoard_1.VastitasBorealisBoard.handleBonusTemperatureFromTilePlacement(game, player, foundSpace);
                            const reservedBonuses = [SpaceBonus_1.SpaceBonus.RESTRICTED];
                            foundSpace.bonus = foundSpace.bonus.filter((bonus) => reservedBonuses.includes(bonus));
                            game.erodedSpaces.push(foundSpace.id);
                            const offset = Math.abs(foundSpace.y - 4);
                            const row = foundSpace.y + 1;
                            const position = foundSpace.x - offset + 1;
                            game.log("${0} eroded space on row ${1} position ${2}", b => b.player(player).number(row).number(position));
                            return undefined;
                        })));
                    }
                }
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_MC_PER_HAZARD_TILE:
                player.megaCredits += AresHazards_1._AresHazardPlacement.getHazardsCount(game);
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_TR:
                if (quantity > 0) {
                    player.increaseTerraformRatingSteps(quantity);
                    LogHelper_1.LogHelper.logTRChange(player, quantity);
                }
                ;
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_VP:
                if (quantity > 0) {
                    player.colonyVictoryPoints += quantity;
                    game.log('${0} gained ${1} VP', (b) => b.player(player).number(quantity));
                }
                break;
            case ColonyBenefit_1.ColonyBenefit.INCREASE_VENUS_SCALE:
                game.increaseVenusScaleLevel(player, quantity);
                game.log('${0} increased Venus scale ${1} step(s)', (b) => b.player(player).number(quantity));
                break;
            case ColonyBenefit_1.ColonyBenefit.LOSE_RESOURCES:
                if (resource === undefined)
                    throw new Error('Resource cannot be undefined');
                player.deductResource(resource, quantity);
                break;
            case ColonyBenefit_1.ColonyBenefit.OPPONENT_DISCARD:
                if (game.isSoloMode())
                    break;
                action = new DeferredAction_1.DeferredAction(player, () => {
                    const playersWithCards = game.getPlayersStillInGame().filter((p) => p.cardsInHand.length > 0);
                    if (playersWithCards.length === 0)
                        return undefined;
                    return new SelectPlayer_1.SelectPlayer(playersWithCards, 'Select player to discard a card', 'Select', (selectedPlayer) => {
                        game.defer(new DiscardCards_1.DiscardCards(selectedPlayer, 1, this.name + ' colony effect. Select a card to discard'));
                        return undefined;
                    });
                });
                break;
            case ColonyBenefit_1.ColonyBenefit.PLACE_OCEAN_TILE:
                action = new PlaceOceanTile_1.PlaceOceanTile(player, 'Select ocean space for ' + this.name + ' colony');
                break;
            case ColonyBenefit_1.ColonyBenefit.STEAL_RESOURCES:
                if (resource === undefined)
                    throw new Error('Resource cannot be undefined');
                action = new StealResources_1.StealResources(player, resource, quantity);
                break;
            case ColonyBenefit_1.ColonyBenefit.DRAW_EARTH_CARD:
                player.drawCard(quantity, { tag: Tags_1.Tags.EARTH });
                break;
            case ColonyBenefit_1.ColonyBenefit.WGT_RAISE_GLOBAL_PARAMETER:
                if (quantity === 0) {
                    game.defer(new DeferredAction_1.DeferredAction(player, () => {
                        game.phase = Phase_1.Phase.SOLAR;
                        if (game.getTemperature() < constants_1.MAX_TEMPERATURE) {
                            game.log('${0} acted as World Government and increased temperature', (b) => b.player(player));
                        }
                        game.increaseTemperature(player, 1);
                        return undefined;
                    }));
                }
                else if (quantity === 1) {
                    game.phase = Phase_1.Phase.SOLAR;
                    if (game.noOceansAvailable() === false) {
                        game.log('${0} acted as World Government and placed an ocean', (b) => b.player(player));
                    }
                    game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select ocean space for ' + this.name + ' colony'));
                }
                else if (quantity === 2) {
                    game.defer(new DeferredAction_1.DeferredAction(player, () => {
                        game.phase = Phase_1.Phase.SOLAR;
                        if (game.getOxygenLevel() < constants_1.MAX_OXYGEN_LEVEL) {
                            game.log('${0} acted as World Government and increased oxygen level', (b) => b.player(player));
                        }
                        game.increaseOxygenLevel(player, 1);
                        return undefined;
                    }));
                }
                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
                break;
            case ColonyBenefit_1.ColonyBenefit.GAIN_MC_FOR_EARTH_TAGS:
                let amount = game.getPlayers()
                    .map((p) => p.getTagCount(Tags_1.Tags.EARTH, p.id === player.id ? 'default' : 'raw'))
                    .reduce((a, c) => a + c, 0);
                if (game.isSoloMode() && game.gameOptions.automaSoloVariant) {
                    amount += AutomaHandler_1.AutomaHandler.getBotTagCount(game);
                }
                player.megaCredits += Math.floor(amount / 3);
                break;
            default:
                throw new Error('Unsupported benefit type');
        }
        if (action !== undefined) {
            if (isGiveColonyBonus) {
                return action.execute();
            }
            else {
                game.defer(action);
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
}
exports.Colony = Colony;
//# sourceMappingURL=Colony.js.map